enum LanguageCode {
  DE = 'de',
  EN = 'en',
  FR = 'fr',
}

export {
  LanguageCode,
};
